import { render, staticRenderFns } from "./CardDownloadList.vue?vue&type=template&id=7bf95590&scoped=true"
import script from "./CardDownloadList.vue?vue&type=script&lang=js"
export * from "./CardDownloadList.vue?vue&type=script&lang=js"
import style0 from "./CardDownloadList.vue?vue&type=style&index=0&id=7bf95590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf95590",
  null
  
)

export default component.exports